import { z } from 'zod';
import { TIME_STRICT_REGEX } from '@/utils/timeConversion';


const bulkAdjustMarkBaseSchema = z.object({
  newTime: z.string()
    .regex(TIME_STRICT_REGEX, 'attendance:marksReport.adjustBulk.validation.invalidTimeFormat')
    .optional()
    .or(z.literal(''))
    .transform((value) => (value ? value : undefined)),
  newEventId: z.string()
    .optional()
    .or(z.literal(''))
    .transform((value) => (value ? value : undefined)),
  comment: z.string()
    .trim()
    .min(1, 'attendance:marksReport.adjustBulk.validation.commentRequired')
    .max(500, 'attendance:marksReport.adjustBulk.validation.commentMaxLength'),
});

export const bulkAdjustMarkFormSchema = bulkAdjustMarkBaseSchema.refine(
  (data) => !!data.newTime || !!data.newEventId,
  {
    message: 'attendance:marksReport.adjustBulk.validation.atLeastOneRequired',
    path: ['newTime'],
  },
);

export type BulkAdjustMarkFormValues = z.infer<typeof bulkAdjustMarkFormSchema>;
